import { create } from "zustand";

const useHeartbeatStore = create((set) => ({
  active_positions: 0,
  tracked_orders: 0,
  total_trades: 0,
  timestamp: null,

  updateHeartbeat: (payload) =>
    set({
      active_positions: payload.active_positions,
      tracked_orders: payload.tracked_orders,
      total_trades: payload.total_trades,
      timestamp: payload.timestamp,
    }),
}));

export default useHeartbeatStore;
